/* Silo Digital — cart rewards bar behaviour.
   The bar itself is server-rendered (and re-rendered by the theme's two cart
   refresh paths); this element re-runs on every reconnect and adds:
   1. Fill animation from the previous value (sessionStorage) to the new one.
   2. One-time unlock celebration + polite screen-reader announcement when a
      tier crosses from locked to unlocked.
   3. Free-gift reconciliation: auto-add the gift variant when its tier is
      unlocked, auto-remove when the cart drops back below. If the shopper
      deletes the gift themselves it stays dismissed until they drop below the
      threshold and earn it again.
   4. Tap-to-copy for the unlocked discount code. */
(function () {
  var K_FILL = 'sd-rewards-fill';
  var K_UNLOCKED = 'sd-rewards-unlocked';
  var K_GIFT_ADDED = 'sd-rewards-gift-added';
  var K_GIFT_DISMISSED = 'sd-rewards-gift-dismissed';
  var ANNOUNCE = {
    ship: 'Free shipping unlocked',
    gift: 'Free gift unlocked, it has been added to your cart',
    code: 'Discount unlocked'
  };
  var giftBusy = false;

  function store(key, value) {
    try { sessionStorage.setItem(key, value); } catch (e) { /* private mode */ }
  }
  function read(key) {
    try { return sessionStorage.getItem(key); } catch (e) { return null; }
  }
  function clear(key) {
    try { sessionStorage.removeItem(key); } catch (e) { /* noop */ }
  }

  function refreshCart() {
    if (document.querySelector('cart-drawer')) {
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    } else {
      var items = document.querySelector('cart-items');
      if (items && typeof items.refresh === 'function') { items.refresh(); } else { window.location.reload(); }
    }
  }

  class SdCartRewards extends HTMLElement {
    connectedCallback() {
      this.animateFill();
      this.checkUnlocks();
      this.bindCopy();
      this.reconcileGift();
    }

    animateFill() {
      var fill = this.querySelector('.sd-rewards__fill');
      if (!fill) { return; }
      var target = parseFloat(this.dataset.fill || '0');
      var prev = parseFloat(read(K_FILL) || '0');
      if (Number.isNaN(prev)) { prev = 0; }
      if (prev !== target) {
        fill.style.width = prev + '%';
        // Double rAF so the initial width paints before the transition starts
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { fill.style.width = target + '%'; });
        });
      } else {
        fill.style.width = target + '%';
      }
      store(K_FILL, String(target));
    }

    checkUnlocks() {
      var current = (this.dataset.unlocked || '').split(',').filter(Boolean);
      var prev = (read(K_UNLOCKED) || '').split(',').filter(Boolean);
      var live = this.querySelector('.sd-rewards__live');
      var self = this;
      var fresh = current.filter(function (k) { return prev.indexOf(k) === -1; });
      fresh.forEach(function (key) {
        var node = self.querySelector('.sd-rewards__node[data-tier="' + key + '"]');
        if (node) {
          // Delay so the pop lands as the fill reaches the node
          setTimeout(function () { node.classList.add('is-celebrate'); }, 350);
        }
        if (live && ANNOUNCE[key]) { live.textContent = ANNOUNCE[key]; }
      });
      store(K_UNLOCKED, current.join(','));
    }

    bindCopy() {
      var btn = this.querySelector('[data-sd-copy-code]');
      if (!btn) { return; }
      btn.addEventListener('click', function () {
        var hint = btn.querySelector('[data-sd-copy-hint]');
        var restore = hint ? hint.textContent : '';
        var done = function () {
          btn.classList.add('is-copied');
          if (hint) { hint.textContent = 'Copied!'; }
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (hint) { hint.textContent = restore; }
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(btn.dataset.sdCopyCode).then(done).catch(done);
        } else { done(); }
      });
    }

    reconcileGift() {
      if (giftBusy) { return; }
      var threshold = parseInt(this.dataset.giftThreshold || '0', 10);
      var variant = this.dataset.giftVariant;
      if (!threshold || !variant) { return; }

      var subtotal = parseInt(this.dataset.subtotal || '0', 10);
      var lineKey = this.dataset.giftLineKey || '';
      var inCart = lineKey !== '';
      var earned = subtotal >= threshold;

      if (!earned) {
        clear(K_GIFT_ADDED);
        clear(K_GIFT_DISMISSED);
        if (inCart) { this.changeGift({ id: lineKey, quantity: 0 }); }
        return;
      }

      if (inCart) {
        store(K_GIFT_ADDED, '1');
        return;
      }

      if (read(K_GIFT_ADDED)) {
        // We added it earlier and it's gone: the shopper removed it. Respect that.
        store(K_GIFT_DISMISSED, '1');
        clear(K_GIFT_ADDED);
        return;
      }

      if (!read(K_GIFT_DISMISSED)) {
        this.addGift(variant);
      }
    }

    addGift(variant) {
      giftBusy = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variant, 10), quantity: 1, properties: { _gift: 'sd-rewards' } }]
        })
      }).then(function (res) {
        if (res.ok) { store(K_GIFT_ADDED, '1'); }
      }).finally(function () {
        giftBusy = false;
        refreshCart();
      });
    }

    changeGift(payload) {
      giftBusy = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).finally(function () {
        giftBusy = false;
        refreshCart();
      });
    }
  }

  if (!customElements.get('sd-cart-rewards')) {
    customElements.define('sd-cart-rewards', SdCartRewards);
  }
})();
